import React from "react";
import { BodyClassContextType } from "types/bodyClassContext";

export const BodyClassContext = React.createContext<BodyClassContextType>({
  bodyClass: [""],
  addClass: (className: string) => {},
  removeClass: (classNameToRemove: string) => {},
});
